export default function Footer() {
  return (
    <footer className="bg-[#1A2B4A] rounded-t-3xl">
      <div className="max-w-7xl mx-auto px-8 py-20">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-12 mb-16">
          {/* Columna 1 - Branding */}
          <div className="md:col-span-4">
            <img 
              src="https://static.readdy.ai/image/a9cd994c46d025e0d95e61b53418f618/218b69a04a5f5113a2da77c66ccead30.png" 
              alt="BN ĀGENZIA Logo" 
              className="h-12 w-auto mb-3"
            />
            <p className="text-gray-400 text-sm mb-8">International Placement</p>
            <p className="text-gray-400 text-sm leading-relaxed mb-8">
              Agencia boutique de colocación internacional. Conectamos empresas europeas con profesionales cualificados mediante selección estratégica y acompañamiento real.
            </p>
            <a 
              href="#contact" 
              className="inline-flex items-center px-6 py-3 border-2 border-white text-white text-sm font-medium rounded-lg hover:bg-white hover:text-[#1A2B4A] transition-all cursor-pointer whitespace-nowrap"
            >
              Contactar
            </a>
          </div>
          
          {/* Columna 2 - Navegación */}
          <div className="md:col-span-2">
            <h3 className="text-white text-lg font-semibold mb-6">Servicios</h3>
            <ul className="space-y-3">
              <li>
                <a href="#services" className="text-gray-400 text-sm hover:text-white transition-colors cursor-pointer">Para empresas</a>
              </li>
              <li>
                <a href="#services" className="text-gray-400 text-sm hover:text-white transition-colors cursor-pointer">Para profesionales</a>
              </li>
              <li>
                <a href="#method" className="text-gray-400 text-sm hover:text-white transition-colors cursor-pointer">Nuestro método</a>
              </li>
              <li>
                <a href="#biblioteca" className="text-gray-400 text-sm hover:text-white transition-colors cursor-pointer">Biblioteca Estratégica</a>
              </li>
              <li>
                <a href="#about" className="text-gray-400 text-sm hover:text-white transition-colors cursor-pointer">Alcance</a>
              </li>
            </ul>
          </div>
          
          {/* Columna 3 - Social */}
          <div className="md:col-span-3">
            <h3 className="text-white text-lg font-semibold mb-6">Síguenos</h3>
            <ul className="space-y-4">
              <li>
                <a href="https://linkedin.com" target="_blank" rel="noopener noreferrer" className="flex items-center gap-3 text-gray-400 text-sm hover:text-white transition-colors cursor-pointer">
                  <i className="ri-linkedin-fill text-xl"></i>
                  LinkedIn
                </a>
              </li>
              <li>
                <a href="https://instagram.com" target="_blank" rel="noopener noreferrer" className="flex items-center gap-3 text-gray-400 text-sm hover:text-white transition-colors cursor-pointer">
                  <i className="ri-instagram-line text-xl"></i>
                  Instagram
                </a>
              </li>
              <li>
                <a href="mailto:info@bnagenzia.com" className="flex items-center gap-3 text-gray-400 text-sm hover:text-white transition-colors cursor-pointer">
                  <i className="ri-mail-line text-xl"></i>
                  info@bnagenzia.com
                </a>
              </li>
            </ul>
          </div>
          
          {/* Columna 4 - Newsletter */}
          <div className="md:col-span-3">
            <h3 className="text-white text-lg font-semibold mb-4">Mantente informado</h3>
            <p className="text-gray-400 text-sm mb-6">Oportunidades y tendencias del mercado europeo</p>
            <div className="flex items-center gap-2">
              <input
                type="email"
                placeholder="Tu email"
                className="flex-1 px-4 py-3 bg-white/10 border border-white/20 rounded-lg text-sm text-white placeholder-gray-400 focus:outline-none focus:ring-2 focus:ring-white/50 transition-all"
              />
              <button className="w-12 h-12 flex items-center justify-center bg-white rounded-full hover:bg-gray-100 transition-colors cursor-pointer">
                <i className="ri-arrow-right-line text-xl text-[#1A2B4A]"></i>
              </button>
            </div>
          </div>
        </div>
        
        {/* Watermark */}
        <div className="relative mb-12 overflow-hidden">
          <p className="text-[#1A2B4A]/10 text-8xl font-extrabold text-center select-none">BN ĀGENZIA</p>
        </div>
        
        {/* Legal bar */}
        <div className="pt-8 border-t border-white/10">
          <div className="flex flex-col md:flex-row justify-between items-center gap-4">
            <p className="text-gray-400 text-sm">© 2025 BN ĀGENZIA. Todos los derechos reservados.</p>
            <div className="flex items-center gap-6">
              <a href="/politica-privacidad" className="text-gray-400 text-sm hover:text-white transition-colors cursor-pointer">Política de privacidad</a>
              <a href="/aviso-legal" className="text-gray-400 text-sm hover:text-white transition-colors cursor-pointer">Aviso legal</a>
              <a href="/politica-cookies" className="text-gray-400 text-sm hover:text-white transition-colors cursor-pointer">Política de cookies</a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}